import { Component } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { AppConfig } from '../../../../app/app.config';
import { SidebarPermissions } from '../../../../models/permissions/permission.models';
import { PageArgs } from '../../../../models/projects/operation.models';
import { SupportContextKey } from '../../../../models/support/support.models';
import { NavHelperService } from '../../../../services/nav/nav-helper.service';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { CyclesPage } from '../../../cycles/cycles';
import { ConfigureProjectPage } from '../../../setup/configure-project/configure-project';
import { TimezoneChangePage } from '../../../setup/timezone-change/timezone-change';

@IonicPage()
@Component({
  selector: 'page-nav-settings-submenu',
  templateUrl: 'nav-settings-submenu.html'
})
export class NavSettingsSubmenuPage {
  config = AppConfig.settings;
  permissions: SidebarPermissions = new SidebarPermissions();
  sidebarCollapsed = false;
  initialSetupComplete = false;
  setupConfigured = false;
  canEnterData = false;
  dailyLogStale = false;
  pages = [];

  constructor(
    private permissionsService: PermissionsService,
    public navHelperService: NavHelperService
  ) {
    this.navHelperService.currentSidebarCollapsed.subscribe(value => this.sidebarCollapsed = value);
    this.navHelperService.currentInitialSetupComplete.subscribe(value => this.initialSetupComplete = value);
    this.navHelperService.currentSetupConfigured.subscribe(value => this.setupConfigured = value);
    this.navHelperService.canEnterData.subscribe(value => this.canEnterData = value);
    this.navHelperService.dailyLogStale.subscribe(value => this.dailyLogStale = value);
  }

  async ionViewDidEnter() {
    this.permissions = await this.permissionsService.sidebarPermissions();
    this.pages = [
      {
        title: 'Edit Project',
        component: ConfigureProjectPage,
        icon: 'md-construct',
        supportContextKey: SupportContextKey.EditProject,
        active: this.permissions.canClickProjectDetails
      },
      {
        title: 'Cycles',
        component: CyclesPage,
        icon: 'md-repeat',
        supportContextKey: SupportContextKey.Cycles,
        active: this.permissions.canClickDailyLog
      },
      {
        title: 'Change Time Zone',
        component: TimezoneChangePage,
        icon: 'md-time',
        supportContextKey: SupportContextKey.ChangeTimeZone,
        active: this.permissions.canClickAddToDailyLog
      }
    ];
  }

  isDisabled(page: any): boolean {
    if (!page.active) {
      return true;
    }

    if (page.title === 'Edit Project') {
      return this.dailyLogStale || (this.initialSetupComplete && !this.canEnterData);
    }

    if (page.title === 'Cycles') {
      return !this.initialSetupComplete;
    }

    return !this.initialSetupComplete || !this.setupConfigured || !this.canEnterData || this.dailyLogStale;
  }

  selectPage(page: any) {
    if (this.isDisabled(page)) {
      return;
    }

    if (this.navHelperService.warned || this.navHelperService.unsavedChanges === false) {
      this.navHelperService.unsavedChanges = false;
      const navPage = new PageArgs();
      navPage.page = page.component;
      navPage.supportContextKey = page.supportContextKey;
      navPage.supportContextLabel = page.title;
      this.navHelperService.updateNavPage(navPage);
      return;
    }

    this.navHelperService.warned = true;
    this.navHelperService.showWarning = true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-settings-submenu/nav-settings-submenu.ts